module.exports = new __parcel__URL__("lockIcon.715fa07c.svg").toString();